var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "input-group",
    {
      attrs: { prepend: true, append: true, icon: "fas fa-filter" },
      scopedSlots: _vm._u(
        [
          _vm.value !== ""
            ? {
                key: "append",
                fn: function() {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "input-group-text clear",
                        on: {
                          click: function($event) {
                            _vm.newValue = ""
                          }
                        }
                      },
                      [_c("i", { staticClass: "fas fa-times" })]
                    )
                  ]
                },
                proxy: true
              }
            : null
        ],
        null,
        true
      )
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.newValue,
            expression: "newValue"
          }
        ],
        ref: "input",
        staticClass: "form-control",
        attrs: { type: "text" },
        domProps: { value: _vm.newValue },
        on: {
          keydown: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
            ) {
              return null
            }
            _vm.newValue = ""
          },
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.newValue = $event.target.value
          }
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }